import { render, staticRenderFns } from "./goods-category.vue?vue&type=template&id=2d4b4438&scoped=true"
import script from "./goods-category.vue?vue&type=script&lang=ts"
export * from "./goods-category.vue?vue&type=script&lang=ts"
import style0 from "./goods-category.vue?vue&type=style&index=0&id=2d4b4438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b4438",
  null
  
)

export default component.exports